import React, { useState } from 'react';

const AreaActivityHeader = ({ 
  selectedRegion, 
  onBreadcrumbClick, 
  timeFrame, 
  setTimeFrame,
  viewMode,
  setViewMode,
  filterGenre,
  setFilterGenre,
  sortBy,
  setSortBy
}) => {
  const [showTimeDropdown, setShowTimeDropdown] = useState(false);
  const [showViewDropdown, setShowViewDropdown] = useState(false);
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const [showSortDropdown, setShowSortDropdown] = useState(false);

  const timeOptions = ['Live', '8hrs', '16hrs', '24hrs'];
  const viewOptions = ['Current View', 'Music Focus', 'Events Focus'];
  const genreOptions = ['All Genres', 'Techno', 'House', 'Trance', 'Dubstep', 'Drum & Bass', 'Deep House', 'Tech House'];
  const sortOptions = ['Activity', 'Trending', 'Recent'];

  return (
    <div style={{
      padding: '15px 25px',
      borderBottom: '2px solid rgba(0, 255, 255, 0.3)',
      background: 'rgba(10, 14, 39, 0.8)',
      display: 'flex',
      alignItems: 'center',
      gap: '20px'
    }}>
      {/* Breadcrumb Navigation */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '14px',
        color: '#00FFFF'
      }}>
        {selectedRegion.path.map((part, index) => (
          <React.Fragment key={part}>
            <span 
              style={{ 
                cursor: 'pointer', 
                fontWeight: index === selectedRegion.path.length - 1 ? '700' : '400',
                opacity: index === selectedRegion.path.length - 1 ? 1 : 0.7,
                transition: 'all 0.2s ease',
                textDecoration: 'none'
              }}
              onClick={() => onBreadcrumbClick(part)}
              onMouseEnter={(e) => {
                e.target.style.opacity = '1';
                e.target.style.textDecoration = 'underline';
                e.target.style.textUnderlineOffset = '3px';
              }}
              onMouseLeave={(e) => {
                if (index !== selectedRegion.path.length - 1) {
                  e.target.style.opacity = '0.7';
                }
                e.target.style.textDecoration = 'none';
              }}
            >
              {part}
            </span>
            {index < selectedRegion.path.length - 1 && (
              <span style={{ color: '#94a3b8', fontSize: '12px' }}>›</span>
            )}
          </React.Fragment>
        ))}
      </div>
      
      {/* Spacer */}
      <div style={{ flex: 1 }}></div>
      
      {/* View Mode Dropdown */}
      <div style={{ position: 'relative' }}>
        <div
          onClick={() => setShowViewDropdown(!showViewDropdown)}
          style={{
            padding: '6px 12px',
            background: 'rgba(0, 255, 255, 0.1)',
            border: '1px solid rgba(0, 255, 255, 0.3)',
            borderRadius: '6px',
            fontSize: '13px',
            color: '#00FFFF',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            minWidth: '140px'
          }}
        >
          View: {viewMode} ▼
        </div>
        
        {showViewDropdown && (
          <div style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            marginTop: '5px',
            background: 'rgba(10, 14, 39, 0.98)',
            border: '1px solid rgba(0, 255, 255, 0.3)',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)',
            zIndex: 1000,
            minWidth: '160px'
          }}>
            {viewOptions.map((option) => (
              <div
                key={option}
                onClick={() => {
                  setViewMode(option);
                  setShowViewDropdown(false);
                }}
                style={{
                  padding: '10px 15px',
                  color: viewMode === option ? '#00FFFF' : '#94a3b8',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontWeight: viewMode === option ? '600' : '400',
                  background: viewMode === option ? 'rgba(0, 255, 255, 0.1)' : 'transparent',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(0, 255, 255, 0.15)';
                  e.target.style.color = '#00FFFF';
                }}
                onMouseLeave={(e) => {
                  if (viewMode !== option) {
                    e.target.style.background = 'transparent';
                    e.target.style.color = '#94a3b8';
                  } else {
                    e.target.style.background = 'rgba(0, 255, 255, 0.1)';
                  }
                }}
              >
                {option}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Genre Filter Dropdown */}
      <div style={{ position: 'relative' }}>
        <div
          onClick={() => setShowFilterDropdown(!showFilterDropdown)}
          style={{
            padding: '6px 12px',
            background: 'rgba(0, 255, 255, 0.1)',
            border: '1px solid rgba(0, 255, 255, 0.3)',
            borderRadius: '6px',
            fontSize: '13px',
            color: '#00FFFF',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            minWidth: '130px'
          }}
        >
          Filter: {filterGenre} ▼
        </div>
        
        {showFilterDropdown && (
          <div style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            marginTop: '5px',
            background: 'rgba(10, 14, 39, 0.98)',
            border: '1px solid rgba(0, 255, 255, 0.3)',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)',
            zIndex: 1000,
            minWidth: '150px',
            maxHeight: '300px',
            overflowY: 'auto'
          }}>
            {genreOptions.map((option) => (
              <div
                key={option}
                onClick={() => {
                  setFilterGenre(option);
                  setShowFilterDropdown(false);
                }}
                style={{
                  padding: '10px 15px',
                  color: filterGenre === option ? '#00FFFF' : '#94a3b8',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontWeight: filterGenre === option ? '600' : '400',
                  background: filterGenre === option ? 'rgba(0, 255, 255, 0.1)' : 'transparent',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(0, 255, 255, 0.15)';
                  e.target.style.color = '#00FFFF';
                }}
                onMouseLeave={(e) => {
                  if (filterGenre !== option) {
                    e.target.style.background = 'transparent';
                    e.target.style.color = '#94a3b8';
                  } else {
                    e.target.style.background = 'rgba(0, 255, 255, 0.1)';
                  }
                }}
              >
                {option}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Sort By Dropdown */}
      <div style={{ position: 'relative' }}>
        <div
          onClick={() => setShowSortDropdown(!showSortDropdown)}
          style={{
            padding: '6px 12px',
            background: 'rgba(0, 255, 255, 0.1)',
            border: '1px solid rgba(0, 255, 255, 0.3)',
            borderRadius: '6px',
            fontSize: '13px',
            color: '#00FFFF',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            minWidth: '120px'
          }}
        >
          Sort: {sortBy} ▼
        </div>
        
        {showSortDropdown && (
          <div style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            marginTop: '5px',
            background: 'rgba(10, 14, 39, 0.98)',
            border: '1px solid rgba(0, 255, 255, 0.3)',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)',
            zIndex: 1000,
            minWidth: '140px'
          }}>
            {sortOptions.map((option) => (
              <div
                key={option}
                onClick={() => {
                  setSortBy(option);
                  setShowSortDropdown(false);
                }}
                style={{
                  padding: '10px 15px',
                  color: sortBy === option ? '#00FFFF' : '#94a3b8',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontWeight: sortBy === option ? '600' : '400',
                  background: sortBy === option ? 'rgba(0, 255, 255, 0.1)' : 'transparent',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(0, 255, 255, 0.15)';
                  e.target.style.color = '#00FFFF';
                }}
                onMouseLeave={(e) => {
                  if (sortBy !== option) {
                    e.target.style.background = 'transparent';
                    e.target.style.color = '#94a3b8';
                  } else {
                    e.target.style.background = 'rgba(0, 255, 255, 0.1)';
                  }
                }}
              >
                {option}
              </div>
            ))}
          </div>
        )}
      </div>
      
      {/* Region Filter Dropdown - REMOVED */}
      {/* Time Range Selector - Dropdown */}
      <div style={{ position: 'relative' }}>
        <div
          onClick={() => setShowTimeDropdown(!showTimeDropdown)}
          style={{
            padding: '6px 12px',
            background: 'rgba(0, 255, 255, 0.1)',
            border: '1px solid rgba(0, 255, 255, 0.3)',
            borderRadius: '6px',
            fontSize: '13px',
            color: '#00FFFF',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          Timeframe: {timeFrame} ▼
        </div>
        
        {showTimeDropdown && (
          <div style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            marginTop: '5px',
            background: 'rgba(10, 14, 39, 0.98)',
            border: '1px solid rgba(0, 255, 255, 0.3)',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)',
            zIndex: 1000,
            minWidth: '120px'
          }}>
            {timeOptions.map((option) => (
              <div
                key={option}
                onClick={() => {
                  setTimeFrame(option);
                  setShowTimeDropdown(false);
                }}
                style={{
                  padding: '10px 15px',
                  color: timeFrame === option ? '#00FFFF' : '#94a3b8',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontWeight: timeFrame === option ? '600' : '400',
                  background: timeFrame === option ? 'rgba(0, 255, 255, 0.1)' : 'transparent',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(0, 255, 255, 0.15)';
                  e.target.style.color = '#00FFFF';
                }}
                onMouseLeave={(e) => {
                  if (timeFrame !== option) {
                    e.target.style.background = 'transparent';
                    e.target.style.color = '#94a3b8';
                  } else {
                    e.target.style.background = 'rgba(0, 255, 255, 0.1)';
                  }
                }}
              >
                {option}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AreaActivityHeader;
